<template>
  <section v-on:click="sectionClicked">
    <Header :class="{scrolled: isScrolled}" ref="header"
      v-if="!loadingLang && live"/>
    <div class="loadingLanguage" v-if="loadingLang"></div>
    <div class="cdSpacer" v-else-if="!live"></div>
    <div v-else>
      <div class="welcome">
        <div class="welcomeBg">
          <div class="wIl wIl1"></div><div class="wIl wIl2"></div>
          <div class="wIl wIl3"></div><div class="wIl wIl4"></div>
        </div>
        <div class="cnt">
          <div class="welcomeCnt">
            <div class="wl">
              <div class="wlHeader">
                <h2 v-if="langCode === 'id'">Temukan Ahli</h2>
                <h2 v-if="langCode === 'en'">Find Experts</h2>
                <p>Stand on the shoulders of giants</p>
              </div>
              <form v-on:submit.prevent="openSearch(q)"
                v-on:click.stop="doNothing">
                <div class="searchIcon" :class="{searching: searching}"></div>
                <input type="text"
                  :placeholder="langCode === 'id' ? 'Cari berdasarkan nama ahli...' : 'Find expert by name...'"
                  v-on:focus="autocompleteOpen = true"
                  v-model="q" v-on:input="searchAutocomplete">
                <button v-if="langCode === 'id'">Cari Ahli</button>
                <button v-if="langCode === 'en'">Search Expert</button>
                <div class="autocomplete"
                  v-if="autocomplete.length > 0 && autocompleteOpen">
                  <li v-for="(ac, i) in autocomplete" :key="i" class="suggestion"
                    v-on:click="openSearch(ac.namaAhli)">
                    <span>{{ac.namaAhli}}</span>
                    <p v-if="ac.gelarAhli">{{ac.gelarAhli}}</p>
                  </li>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="cnt">
        <div class="profileAhli">
          <div class="profileAhliTitle">
            <h4 v-if="langCode === 'id'">Profil Ahli</h4>
            <h4 v-if="langCode === 'en'">Expert Profil</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
          </div>
          <div class="ahliCnt" :class="{ltf: allAhli.length < 4}">
            <div class="ahliItem" v-for="(item, i) in allAhli" :key="i">
              <div class="ahliPict" v-if="item.fotoAhli"
                :style="{'background-image': `url(${item.fotoAhli.imageSm})`}"></div>
              <div class="ahliPict noImg" v-else></div>
              <div class="ahliInfo">
                <h4>{{item.namaAhli}}</h4>
                <div class="ahliTitle">{{item.gelarAhli}}</div>
                <div class="tanggapanCount">{{item.totalTanggapan}}
                  <template v-if="langCode === 'id'">Tanggapan</template>
                  <template v-if="langCode === 'en'">Response</template>
                </div>
                <a :href="`/ahli/${item.namaAhli}`" class="btn btnPrimary" v-if="langCode === 'id'">Lihat Tangapan</a>
                <a :href="`/ahli/${item.namaAhli}`" class="btn btnPrimary" v-if="langCode === 'en'">See Response</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    <Countdown v-on:live="onLive"/>
  </section>
</template>

<script>
import ApexCharts from 'apexcharts';
import Header from '@/components/Header.vue';
import Countdown from '@/components/Countdown.vue';
import Footer from '@/components/Footer.vue';

const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

export default {
  name: 'home',
  components: {
    Header,
    Countdown,
    Footer,
  },
  data() {
    return {
      isScrolled: false,
      loadingSlider: true,
      slidePos: 0,
      provinceStats: null,
      provinceFilter: [],
      statsDrawed: false,
      map: null,
      autocompleteOpen: false,
      autocomplete: [],
      allSlider: [],
      parentSlug: '',
      lastUpload: [],
      q: '',
      searching: false,
      searchTimer: null,
      live: false,

      /**
       * Location
       *
       */
      showAllLocation: false,

      /**
       * Chart
       *
       */
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      loadingChart: true,

      /**
       * Tanggapan ahli
       *
       */
      ahliPos: 1,
      tanggapanAhli: [],

      /**
       * Language
       *
       */
      loadingLang: true,
      langCode: 'id',
      lang: null,

      allAhli: [],
    };
  },
  created() {
    document.addEventListener('scroll', this.scrolled);
    window.addEventListener('resize', this.resized);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
    window.removeEventListener('resize', this.resized);
  },
  computed: {
    ahliPosClass() {
      return `pos${this.ahliPos}`;
    },
  },
  methods: {
    doNothing() {},
    searchAutocomplete() {
      if (!this.q || this.q.trim() === '') {
        this.autocompleteOpen = false;
        return;
      }
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searching = true;
        this.autocompleteOpen = true;
        this.$http.get(this.$config.uri(`content/all-ahli/autocomplete?q=${this.q}`)).then((r) => {
          this.searching = false;
          this.autocomplete = (r.data.status === 200) ? r.data.data : [];
        });
      }, 500);
    },
    openLocation(item) {
      this.$router.push(`/${this.parentSlug}?loc=${item.value}`);
    },
    openSearch(q) {
      // eslint-disable-next-line
      if (!q) q = '';
      const qEncoded = encodeURI(q);
      this.$router.push(`/ahli/${qEncoded}`);
    },
    tagClicked(tag) {
      // const tagEncoded = encodeURI(tag.title);
      // this.$router.push(`/${this.parentSlug}?q=${tagEncoded}`);
      this.$router.push(`/${this.parentSlug}/${tag.slug}`);
    },
    sectionClicked() {
      this.$refs.header.sectionClicked();
      this.autocompleteOpen = false;
    },
    scrolled() {
      this.isScrolled = window.scrollY > 30;
    },
    resized() {
      if (!this.map) return;
      if (window.innerWidth <= 760) {
        this.map.setZoom(2.5);
      } else if (window.innerWidth <= 1076) {
        this.map.setZoom(3.5);
      } else if (window.innerWidth <= 1480) {
        this.map.setZoom(4);
      } else {
        this.map.setZoom(4.3);
      }
    },
    getData() {
      this.$http.get(this.$config.uri('misc/stats/province')).then((r) => {
        if (r.data.status !== 200) return;
        this.provinceStats = r.data.data;
        this.drawMapData();
      });
    },
    getLastUpload() {
      this.$http.get(this.$config.uri('content/gugatan-terakhir')).then((r) => {
        if (r.data.status !== 200) return;
        this.lastUpload = r.data.data;
      });
    },
    getSlider() {
      this.$http.get(this.$config.uri('slider/all')).then((r) => {
        if (r.data.status !== 200) return;
        this.allSlider = r.data.data;
        this.loadingSlider = false;
      });
    },
    getChart() {
      this.$http.get(this.$config.uri(`misc/stats/all?lang=${this.langCode}`)).then((r) => {
        this.loadingChart = false;
        if (r.data.status !== 200) return;
        const stats = r.data.data;

        let i = 0;
        // eslint-disable-next-line
        for (const stat of stats) {
          if (this[`chart${i + 1}`]) this[`chart${i + 1}`].destroy();
          this[`chart${i + 1}`] = new ApexCharts(document.querySelector(`#chart${i + 1}`), {
            chart: {
              height: 600,
              type: 'donut',
              // fontFamily: '"Rubik", sans-serif',
              fontFamily: '"Helvetica Neue", Helvetica, Arial, "Lucida Grande", "Inter", sans-serif',
              toolbar: { show: false },
            },
            colors: ['#379e67', '#1F78B4', '#FB9A99', '#FDBF6F', '#FF7F00'],
            series: stat.series,
            labels: stat.chartCategories,
            legend: {
              position: 'bottom',
            },
            responsive: [
              // { breakpoint: 1480, options: { chart: { height: 500 } } },
              // { breakpoint: 1080, options: { chart: { height: 400 } } },
              // { breakpoint: 680, options: { chart: { height: 260 } } },
            ],
          });
          this[`chart${i + 1}`].render();
          i += 1;
        }

        // this.chart = new ApexCharts(document.querySelector('#chart'), {
        //   chart: {
        //     height: 600,
        //     type: 'bar',
        //     fontFamily: '"Source Serif Pro", serif',
        //     toolbar: { show: false },
        //   },
        //   legend: { itemMargin: { horizontal: 10 } },
        //   yaxis: { show: false },
        //   // dataLabels: { enabled: true, position: 'bottom' },
        //   grid: { show: false },
        //   stroke: { show: false },
        //   plotOptions: {
        //     bar: {
        //       borderRadius: 3,
        //       columnWidth: '80%',
        //       barHeight: '80%',
        //       dataLabels: {
        //         position: 'bottom',
        //       },
        //     },
        //   },
        //   colors: ['#1F78B4', '#FB9A99', '#FDBF6F', '#FF7F00'],
        //   series: r.data.series,
        //   xaxis: {
        //     axisBorder: { show: false },
        //     categories: r.data.categories,
        //   },
        //   responsive: [
        //     { breakpoint: 1480, options: { chart: { height: 500 } } },
        //     { breakpoint: 1080, options: { chart: { height: 400 } } },
        //     { breakpoint: 680, options: { chart: { height: 260 } } },
        //   ],
        // });
        // this.chart.render();
      });
    },
    drawMapData() {
      if (!this.map || !this.map.loaded() || !this.provinceStats
        || this.statsDrawed) return;
      this.statsDrawed = true;
      this.map.addSource('provinceStats', {
        type: 'geojson',
        data: this.provinceStats,
      });
      const fontSize = (window.innerWidth <= 760) ? 8 : 12;
      const circleSize = (window.innerWidth <= 760)
        ? ['step', ['get', 'count'], 8, 100, 10, 750, 12]
        : ['step', ['get', 'count'], 12, 100, 14, 750, 16];
      this.map.addLayer({
        id: 'provinceStat',
        type: 'circle',
        source: 'provinceStats',
        paint: {
          'circle-color': ['step', ['get', 'count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
          'circle-radius': circleSize,
          'circle-stroke-width': 2,
          'circle-stroke-color': '#fff',
        },
      });
      this.map.addLayer({
        id: 'provinceStatLabel',
        type: 'symbol',
        source: 'provinceStats',
        layout: {
          'text-field': '{count}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': fontSize,
        },
      });
      // this.map.on('click', 'provinceStat', (e) => {
      //   const features = this.map.queryRenderedFeatures(e.point, {
      //     layers: ['provinceStat'],
      //   });
      // });
      // this.map.on('mouseenter', 'provinceStat', () => {
      //   this.map.getCanvas().style.cursor = 'pointer';
      // });
      // this.map.on('mouseleave', 'provinceStat', () => {
      //   this.map.getCanvas().style.cursor = '';
      // });
    },
    getTanggapanAhli() {
      this.$http.get(this.$config.uri('misc/tanggapan-ahli')).then((r) => {
        this.tanggapanAhli = (r.data.status === 200) ? r.data.data : [];
        if (this.tanggapanAhli.length < 3) this.ahliPos = 0;
      });
    },
    onLive() {
      this.live = true;
      this.$emit('live');
      setTimeout(() => {
        this.$http.get(this.$config.uri(`misc/lang/${this.langCode}`)).then((rlang) => {
          this.loadingLang = false;
          this.lang = rlang.data.data;
          setTimeout(() => {
            this.$http.get(this.$config.uri(`misc/province/filter?lang=${this.langCode}`)).then((rpv) => {
              this.provinceFilter = (rpv.data.status === 200) ? rpv.data.data : [];
            });
            this.$http.get(this.$config.uri('content/parents')).then((r) => {
              if (r.data.status !== 200) return;
              const [parent] = r.data.data;
              this.parentSlug = parent.slug;
              this.getSlider();
              this.getLastUpload();
              this.getData();
            });
            this.getChart();
            this.getTanggapanAhli();
            mapboxgl.accessToken = this.$config.mapboxAccessToken;
            let zoomLevel = 0.0;
            if (window.innerWidth <= 760) {
              zoomLevel = 2.5;
            } else if (window.innerWidth <= 1076) {
              zoomLevel = 3.5;
            } else if (window.innerWidth <= 1480) {
              zoomLevel = 4;
            } else {
              zoomLevel = 4.3;
            }
            this.map = new mapboxgl.Map({
              container: 'mapbox',
              attributionControl: false,
              style: 'mapbox://styles/actionlab/cl07gazup001m16qc6t10ok8e',
              interactive: false,
              /**
               * For using bounds
               *
               */
              // bounds: new mapboxgl.LngLatBounds(
              //   new mapboxgl.LngLat(90.92386768578021, 8.137613327026926),
              //   new mapboxgl.LngLat(147.02911273294274, 6.976238141033819),
              //   new mapboxgl.LngLat(146.44332711524814, -14.017854758723603),
              //   new mapboxgl.LngLat(-13.67169427407319, 89.50107086120204),
              // ),
              center: [118.0317679347921, -2.590911230954267],
              zoom: zoomLevel,
            });
            this.map.on('load', () => {
              this.drawMapData();
            });

            clearInterval(sliderTimer);
            sliderTimer = setInterval(() => {
              if (this.slidePos === 2) this.slidePos = 0;
              else this.slidePos += 1;
            }, 5000);
          });
        });
      });
    },
    getAhli() {
      this.$http.get(this.$config.uri('content/all-ahli')).then((r) => {
        this.allAhli = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {
    this.langCode = localStorage.getItem('portal_putusan_penting_icel_lang') || 'id';
    // if (!this.langCode) this.langCode = window.navigator.userLanguage || window.navigator.language;
    // if (this.langCode === 'en-US' || this.langCode === 'en') this.langCode = 'en';
    // else if (this.langCode === 'id-ID' || this.langCode === 'id') this.langCode = 'id';
    // else this.langCode = 'en';
    // this.onLive();
    this.getAhli();
  },
};
</script>

<style scoped lang="scss">
#chart.loadingChart{
  height: 400px;
  background-image: url(../assets/loading.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 46px auto;
  @media (max-width: 760px) {
    height: 200px;
    background-size: 36px auto;
  }
}

.cdSpacer{
  height: 100vh;
  min-height: 640px;
}

.welcome{
  position: relative;
  padding: 80px 0 0;
  @media (max-width: 680px) {
    padding-top: 60px;
  }
  .welcomeBg{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    z-index: 3;
    overflow: hidden;
    // background-image: url(../assets/bg-icel.png);
    // background-size: 200px auto;
    opacity: .15;
    // display: none;
    .wIl{
      position: absolute;
      width: 340px; height: 340px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      display: none;
      &.wIl1{
        background-image: url(../assets/wil-1.png);
        left: -120px; top: 60px;
        width: 360px; height: 180px;
      }
      &.wIl2{
        background-image: url(../assets/wil-2.png);
        width: 140px; height: 100px;
        right: -40px; top: 60px;
      }
      &.wIl3{
        background-image: url(../assets/wil-3.png);
        width: 140px; height: 100px;
        right: -10px; bottom: 0;
      }
      &.wIl4{
        background-image: url(../assets/wil-4.png);
        left: -40px; bottom: 0;
      }
    }
  }
  .welcomeCnt{
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
    text-align: center;
    z-index: 7;
    @media (max-width: 890px) {
      display: block;
    }
    .wl{
      width: calc(100% - 400px);
      // margin-right: auto;
      max-width: 840px;
      padding: 140px 0;
      @media (max-width: 1480px) {
        padding: 120px 0;
      }
      @media (max-width: 1060px) {
        width: calc(100% - 340px);
      }
      @media (max-width: 890px) {
        width: auto;
        text-align: center;
        padding: 100px 0 40px;
      }
      @media (max-width: 680px) {
        padding: 60px 0 30px;
      }
      .wlHeader{
        margin: 0 0 30px;
        @media (max-width: 1060px) {
          margin-bottom: 20px;
        }
        h2{
          // font-family: 'Source Serif Pro', serif;
          font-weight: 600;
          font-size: 46px;
          white-space: pre-wrap;
          margin: 0 0 4px;
          @media (max-width: 1480px) {
            font-size: 40px;
          }
          @media (max-width: 1160px) {
            font-size: 36px;
          }
          @media (max-width: 1060px) {
            font-size: 32px;
          }
          @media (max-width: 680px) {
            font-size: 24px;
          }
        }
        p{
          font-size: 20px;
          margin: 0;
          @media (max-width: 640px) {
            font-size: 15px;
          }
        }
      }
      form{
        position: relative;
        margin: 0 0 30px;
        @media (max-width: 1060px) {
          margin-bottom: 20px;
        }
        @media (max-width: 890px) {
          max-width: 640px;
          margin: 0 auto 20px;
        }
        .searchIcon{
          position: absolute;
          left: 10px; top: 0; bottom: 2px;
          z-index: 3; width: 30px;
          background-image: url(../assets/search.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          &.searching{
            background-image: url(../assets/loading.svg);
            background-size: 24px auto;
          }
        }
        input{
          padding: 14px 14px;
          width: 100%;
          border-radius: 5px;
          box-sizing: border-box;
          border: #ccc 1px solid;
          padding-left: 46px;
          // font-family: 'Source Serif Pro', serif;
          font-weight: 400;
          font-size: 16px;
          background-color: #fff;
          &:hover{
            border-color: #222;
          }
        }
        button{
          position: absolute;
          right: 0; top: 0; bottom: 0;
          z-index: 3;
          font-size: 16px;
          padding: 0 20px;
          border-radius: 0 3px 3px 0;
          @media (max-width: 680px) {
            display: none;
          }
        }
        .autocomplete{
          position: absolute;
          left: 0; right: 0; top: 100%;
          background-color: #fff;
          box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
          border-radius: 5px;
          padding: 10px 0;
          li{
            list-style: none;
            // font-family: 'Source Serif Pro', serif;
            font-weight: 400;
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 10px 20px;
            padding-left: 46px;
            cursor: pointer;
            position: relative;
            text-align: left;
            &:before{
              content: "";
              position: absolute;
              left: 10px; top: 5px; height: 30px;
              z-index: 3; width: 30px;
              background-image: url(../assets/search.png);
              background-size: 18px auto;
              background-position: center;
              background-repeat: no-repeat;
              opacity: .3;
            }
            &.suggestion{
              &:before{
                background-image: url(../assets/link.png);
              }
            }
            p{
              margin: 1px 0 0;
              font-size: 12px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #767676;
              max-width: 80%;
            }
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
      }
      .tags{
        .tagTitle{
          // font-family: 'Source Serif Pro', serif;
          font-weight: 400;
          font-size: 18px;
          margin: 0 0 10px;
          @media (max-width: 680px) {
            font-size: 16px;
          }
        }
        .tagCnt{
          display: flex;
          flex-wrap: wrap;
          @media (max-width: 890px) {
            justify-content: center;
          }
          .tagItem{
            border: #115457 1px solid;
            border-radius: 3px;
            padding: 8px 14px 6px;
            // font-family: 'Source Serif Pro', serif;
            font-size: 14px;
            margin: 0 10px 10px 0;
            font-weight: 400;
            background-color: #fff;
            transition: all .2s ease;
            cursor: pointer;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 300px;
            @media (max-width: 1060px) {
              font-size: 13px;
              margin: 0 8px 8px 0;
            }
            &:hover{
              background-color: #369d66;
              border-color: #369d66;
              color: #fff;
            }
          }
        }
      }
    }
    .wr{
      width: 400px;
      padding-left: 60px;
      box-sizing: border-box;
      margin-top: -22px;
      @media (max-width: 1060px) {
        width: 340px;
      }
      @media (max-width: 890px) {
        margin: 0 auto 100px;
        width: 280px;
        padding: 0;
      }
      @media (max-width: 680px) {
        margin-bottom: 60px;
      }
      .wImg{
        position: relative;
        .wImgCnt{
          position: relative;
          overflow: hidden;
          .wImgItemCnt{
            width: 1020px;
            display: flex;
            transition: all .5s ease;
            @media (max-width: 1060px) {
              width: 840px;
            }
            &.pos1{
              margin-left: -340px;
              @media (max-width: 1060px) {
                margin-left: -280px;
              }
            }
            &.pos2{
              margin-left: -680px;
              @media (max-width: 1060px) {
                margin-left: -560px;
              }
            }
            .wImgItem{
              height: 540px;
              width: 100%;
              border-radius: 10px;
              background-position: center;
              background-size: cover;
              @media (max-width: 1060px) {
                height: 444px;
              }
              &.slide1{
                background-image: url(../assets/welcome-slide-1.jpg);
              }
              &.slide2{
                background-image: url(../assets/welcome-slide-2.jpg);
              }
              &.slide3{
                background-image: url(../assets/welcome-slide-3.jpg);
              }
              &.loading{
                background-color: #eee;
                background-image: url(../assets/loading.svg);
                background-size: 46px auto;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
          }
        }
        .wlPaging{
          position: absolute;
          left: -18px; right: -18px; top: 50%;
          transform: translateY(-50%);
          display: flex;
          z-index: 9;
          justify-content: space-between;
          .wlPagingItem{
            background-color: #fff;
            width: 36px; height: 36px;
            border-radius: 50%;
            cursor: pointer;
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
            transition: all .3s ease;
            &:hover{
              box-shadow: 0 0 4px rgba(0, 0, 0, .1);
            }
            &.left{
              margin-right: auto;
              background-image: url(../assets/arrow-left-black.png);
            }
            &.right{
              margin-left: auto;
              background-image: url(../assets/arrow-right-black.png);
            }
          }
        }
      }
      .wlFooter{
        display: flex;
        .wlPager{
          display: flex;
          margin-right: auto;
          padding: 12px 3px 0;
          .pItem{
            width: 10px; height: 10px;
            background-color: #ccc;
            margin-right: 4px;
            border-radius: 50%;
            transition: all .3s ease;
            cursor: pointer;
            &:hover{
              background-color: #999;
            }
            &.active{
              background-color: #558788;
            }
          }
        }
        .wlImgInfo{
          position: relative;
          .theInfo{
            font-size: 12px;
            position: absolute;
            right: 0; top: 10px;
            white-space: nowrap;
            opacity: 0;
            transition: all .2s ease;
            // font-family: 'Source Serif Pro', serif;
            font-style: italic;
            font-weight: 400;
            color: #444;
            &.active{
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

.mapCnt{
  background-color: #f2fdfa;
  padding: 60px 0 0;
  margin-bottom: 60px;
  @media (max-width: 680px) {
    padding-top: 40px;
  }
  .mapboxCnt{
    position: relative;
    height: 560px;
    z-index: 12;
    @media (max-width: 1480px) {
      height: 460px;
    }
    @media (max-width: 1076px) {
      height: 340px;
    }
    @media (max-width: 760px) {
      height: 240px;
    }
    #mapbox{
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-size: 15px;
      position: absolute;
      left: 0; top: 0;
      width: 100%; height: 100%;
    }
    .legendBtn{
      background-color: #fff;
      padding: 4px 14px;
      text-align: center;
      position: absolute;
      z-index: 3;
      right: 10px; bottom: 10px;
      color: #56ab7b;
      font-weight: 500;
      border-radius: 50px;
      font-size: 12px;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      padding-left: 34px;
      display: none;
      @media (max-width: 680px) {
        display: block;
      }
      &:before{
        content: "";
        position: absolute;
        left: 10px; top: 0; width: 20px; bottom: 0;
        background-image: url(../assets/up-arrow-close-green.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .mapLegendOverlay{
      position: fixed;
      left: 0; top: 0; right: 0; bottom: 0;
      background-color: rgba(0, 0, 0, .46);
      z-index: 991;
      display: none;
      @media (max-width: 680px) {
        display: block;
      }
    }
    .mapLegend{
      position: absolute;
      z-index: 3;
      background-color: #fff;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      right: 30px; top: 0;
      border-radius: 5px;
      @media (max-width: 680px) {
        position: fixed;
        left: 50%; top: 50%;
        transform: translate(-50%, -50%);
        width: 260px;
        z-index: 992;
        display: none;
        &.showAll{
          display: block;
        }
      }
      .close{
        position: absolute;
        right: 8px; top: 8px;
        width: 20px; height: 20px;
        background-color: #ddd;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 8px auto;
        opacity: .56;
        background-position: center;
        background-repeat: no-repeat;
        display: none;
        @media (max-width: 680px) {
          display: block;
        }
      }
      h4{
        font-size: 14px;
        margin: 0;
        padding: 14px 20px 10px;
        border-bottom: #eee 1px solid;
      }
      .viewMore{
        font-size: 12px;
        padding: 4px 20px 16px;
        color: #369d66;
        cursor: pointer;
        @media (max-width: 680px) {
          display: none;
        }
        &.less{
          padding-top: 0;
          margin-top: -2px;
        }
      }
      .legendItemCnt{
        padding: 10px 0;
        height: 48px;
        overflow: hidden;
        li{
          list-style: none;
          font-size: 12px;
          padding: 6px 20px;
          padding-right: 46px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          transition: all .3s ease;
          max-width: 220px;
          box-sizing: border-box;
          position: relative;
          @media (max-width: 680px) {
            max-width: none;
            &:nth-child(even) {
              background-color: #f5f5fe;
            }
          }
          span{
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          &:hover{
            background-color: #f5f5fe;
          }
          .count{
            color: #fff;
            margin-left: 16px;
            width: 20px; height: 20px;
            background-color: #56ab7b;
            border-radius: 50%;
            text-align: center;
            padding-top: 2px;
            box-sizing: border-box;
            position: absolute;
            right: 14px; top: 3px;
          }
        }
      }
      &.showAll{
        .legendItemCnt{
          height: auto;
        }
      }
    }
  }
}

.sectionTitle{
  // font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 28px;
}

.chartCnt{
  padding: 60px 0 0;
  margin-bottom: 60px;
  @media (max-width: 680px) {
    padding: 0;
  }
  .sectionTitle{
    margin-bottom: 60px;
    @media (max-width: 740px) {
      margin-bottom: 20px;
    }
  }
  .theChart{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 60px;
    @media (max-width: 1200px) {
      padding-bottom: 20px;
    }
    .chartItem{
      width: 25%;
      box-sizing: border-box;
      padding: 0 30px;
      margin-left: 0 auto;
      @media (max-width: 1200px) {
        width: 50%;
        padding: 0 100px 40px;
      }
      @media (max-width: 960px) {
        padding: 0 60px 40px;
      }
      @media (max-width: 740px) {
        width: 100%;
        padding: 0 200px 40px;
      }
      @media (max-width: 680px) {
        padding: 0 160px 40px;
      }
      @media (max-width: 600px) {
        padding: 0 100px 40px;
      }
      @media (max-width: 500px) {
        padding: 0 40px 40px;
      }
      h4{
        text-align: center;
        margin: 0 0 20px;
        font-size: 20px;
        color: #444;
        font-weight: normal;
        // font-family: 'Inter', sans-serif;
        @media (max-width: 740px) {
          font-size: 18px;
          margin: 0 0 10px;
        }
      }
    }
  }
}

.tanggapanAhliCnt{
  padding: 40px 0 120px;
  @media (max-width: 680px) {
    padding-bottom: 80px;
  }
  .sectionTitle{
    @media (max-width: 680px) {
      margin-bottom: 10px;
    }
  }
}
.detailAhli{
  position: relative;
  .wlPaging{
    position: absolute;
    left: 165px; right: 165px; top: 50%;
    transform: translateY(-50%);
    display: flex;
    z-index: 9;
    justify-content: space-between;
    @media (max-width: 1480px) {
      left: 65px; right: 65px;
    }
    @media (max-width: 1140px) {
      left: -14px; right: -14px;
      // left: 165px; right: 165px;
    }
    @media (max-width: 960px) {
      // left: 65px; right: 65px;
    }
    @media (max-width: 740px) {
      left: -14px; right: -14px;
    }
    .wlPagingItem{
      width: 36px; height: 36px;
      border-radius: 50%;
      cursor: pointer;
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #fff;
      // background-color: #f2fdfa;
      // border: #eee 1px solid;
      transition: all .3s ease;
      &:hover{
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        // background-color: #369d66;
        background-color: #115457;
      }
      &.left{
        margin-right: auto;
        background-image: url(../assets/arrow-left-black.png);
        &:hover{
          background-image: url(../assets/arrow-left-white.png);
        }
      }
      &.right{
        margin-left: auto;
        background-image: url(../assets/arrow-right-black.png);
        &:hover{
          background-image: url(../assets/arrow-right-white.png);
        }
      }
    }
  }
  .wlPager{
    position: absolute;
    bottom: -16px; left: 50%;
    transform: translateX(-50%);
    display: flex;
    margin-right: auto;
    .pItem{
      width: 8px; height: 8px;
      background-color: #ccc;
      margin-right: 4px;
      border-radius: 50%;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #999;
      }
      &.active{
        background-color: #558788;
      }
    }
  }
  .ahliSliderCnt{
    margin: 0 -20px;
    position: relative;
    @media (max-width: 960px) {
      margin: 0 -16px;
    }
    .ahliSlider{
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: 0 200px;
      @media (max-width: 1480px) {
        padding: 0 100px;
      }
      @media (max-width: 1140px) {
        padding: 0 20px;
      }
      @media (max-width: 960px) {
        // padding: 0 100px;
      }
      @media (max-width: 740px) {
        // padding: 0 20px;
      }
      .ahliSc{
        display: flex;
        box-sizing: border-box;
        transition: all .3s ease;
        &.pos1{ margin-left: -100%; }
        &.pos2{ margin-left: -200%; }
        &.pos3{ margin-left: -300%; }
        &.pos4{ margin-left: -400%; }
        &.pos5{ margin-left: -500%; }
        &.pos6{ margin-left: -600%; }
        &.pos7{ margin-left: -700%; }
        &.pos8{ margin-left: -800%; }
        &.pos9{ margin-left: -900%; }
        &.pos10{ margin-left: -1000%; }
        &.pos11{ margin-left: -1100%; }
        &.pos12{ margin-left: -1200%; }
        &.pos13{ margin-left: -1300%; }
        &.pos14{ margin-left: -1400%; }
        &.pos15{ margin-left: -1500%; }
        &.pos16{ margin-left: -1600%; }
        &.pos17{ margin-left: -1700%; }
        &.pos18{ margin-left: -1800%; }
        &.pos19{ margin-left: -1900%; }
        &.pos20{ margin-left: -2000%; }
        &.pos21{ margin-left: -2100%; }
        &.pos22{ margin-left: -2200%; }
        &.pos23{ margin-left: -2300%; }
        &.pos24{ margin-left: -2400%; }
        &.pos25{ margin-left: -2500%; }
        &.pos26{ margin-left: -2600%; }
        &.pos27{ margin-left: -2700%; }
        &.pos28{ margin-left: -2800%; }
        &.pos29{ margin-left: -2900%; }
        &.pos30{ margin-left: -3000%; }
        &.pos31{ margin-left: -3100%; }
        &.pos32{ margin-left: -3200%; }
        &.pos33{ margin-left: -3300%; }
        &.pos34{ margin-left: -3400%; }
        &.pos35{ margin-left: -3500%; }
        &.pos36{ margin-left: -3600%; }
        &.pos37{ margin-left: -3700%; }
        &.pos38{ margin-left: -3800%; }
        &.pos39{ margin-left: -3900%; }
        &.pos40{ margin-left: -4000%; }
        &.pos41{ margin-left: -4100%; }
        &.pos42{ margin-left: -4200%; }
        &.pos43{ margin-left: -4300%; }
        &.pos44{ margin-left: -4400%; }
        &.pos45{ margin-left: -4500%; }
        &.pos46{ margin-left: -4600%; }
        &.pos48{ margin-left: -4800%; }
        &.pos49{ margin-left: -4900%; }
        &.pos50{ margin-left: -5000%; }
        .ahliItem{
          box-sizing: border-box;
          padding: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: #fff;
          // background-color: #f2fdfa;
          background-color: #369d66;
          background-color: #f2fdfa;
          // border: #eee 1px solid;
          // box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
          margin: 6px 0;
          border-radius: 10px;
          transform: scale(.9);
          transition: all .3s ease;
          // font-family: 'Source Serif Pro', serif;
          position: relative;
          color: #444;

          min-height: 200px;
          padding-left: 300px;
          @media (max-width: 890px) {
            padding-left: 260px;
          }
          @media (max-width: 820px) {
            padding-left: 40px;
          }
          @media (max-width: 740px) {
            transform: scale(.94);
          }
          @media (max-width: 680px) {
            min-height: 0;
            text-align: center;
            padding: 26px 16px 20px;
          }
          .theContent{
            font-weight: bold;
            font-size: 24px;
            // color: #fff;
            display: inline-block;
            @media (max-width: 680px) {
              // padding: 20px 0 0;
              font-size: 17px;
            }
          }
          .tanggapanAhliContent{
            &.left{
              text-align: left;
            }
            &.right{
              text-align: right;
            }
            &.center{
              text-align: center;
            }
            &.justify{
              text-align: justify;
            }
          }
          .tanggapanAhli{
            position: relative;
            .quote{
              font-size: 94px;
              position: absolute;
              left: -20px; top: 0;
              color: #369d66;

              position: static;
              line-height: 1;
              height: 32px;
              margin: 0 0 16px;
              @media (max-width: 680px) {
                // left: -10px; top: 6px;
                font-size: 60px;
                margin-bottom: 0;
                height: 26px;
              }
            }
            p{
              font-size: 18px;
              line-height: 1.4;
              padding-left: 30px;

              padding: 0;
              font-size: 22px;
              line-height: 1.3;
              margin: 6px 0 10px;
              @media (max-width: 680px) {
                font-size: 16px;
                // padding: 0 0 0 20px;
                line-height: 1.3;
              }
            }
          }
          &.active{
            transform: none;
          }
        }
      }
    }
  }
  .viewDetail{
    border: #fff 1px solid;
    border-radius: 3px;
    padding: 8px 14px;
    padding-left: 40px;
    transition: all .3s ease;
    cursor: pointer;
    display: inline-block;
    color: #fff;
    background-color: #fff;
    border-color: #fff;
    font-weight: 600;
    // font-family: 'Inter', sans-serif;
    // color: #369d66;

    background-color: #115457;
    border-color: #115457;
    display: inline-block;
    margin: 20px 0 10px;
    // font-weight: 400;
    position: relative;
    &:before{
      content: "";
      position: absolute;
      left: 10px; top: 0; bottom: 2px; width: 20px;
      background-image: url(../assets/link-white.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    @media (max-width: 680px) {
      text-align: center;
    }
    &:hover{
      background-color: #369d66;
      border-color: #369d66;
      box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
    }
  }
  .ahli{
    position: relative;
    padding: 6px 0 22px 74px;
    // margin-top: auto;

    position: static;
    padding: 6px 0 22px;
    @media (max-width: 820px) {
      position: relative;
      padding-left: 74px;
    }
    @media (max-width: 680px) {
      padding: 10px 0 16px;
      text-align: center;
    }
    .ahliPict{
      width: 60px; height: 60px;
      background-color: #eee;
      background-color: rgba(0, 0, 0, .1);
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 50%;
      position: absolute;
      left: 0; top: 0;

      left: 60px; top: 50%;
      width: 180px; height: 180px;
      margin-top: -90px;
      @media (max-width: 820px) {
        width: 140px; height: 140px;
        margin-top: -80px;
        left: 0; top: 0;
        margin: 0;
      }
      @media (max-width: 820px) {
        width: 60px; height: 60px;
      }
      @media (max-width: 680px) {
        position: relative;
        margin: 0 auto 10px;
      }
      &.noImg{
        &:before{
          position: absolute;
          content: "";;
          left: 0; top: 0; right: 0; bottom: 0;
          background-image: url(../assets/image-black.png);
          background-position: center;
          background-size: 46px auto;
          background-repeat: no-repeat;
          opacity: .3;
          @media (max-width: 820px) {
            background-size: 26px auto;
            left: 0; top: 0;
          }
        }
      }
    }
    h4{
      margin: 0;
      font-size: 22px;
      @media (max-width: 680px) {
        font-size: 17px;
      }
    }
    p{
      margin: 0;
      font-size: 20px;
      @media (max-width: 680px) {
        font-size: 16px;
      }
    }
  }
}

.twoImage{
  display: flex;
  box-sizing: border-box;
  margin: 0 40px;
  overflow: hidden;
  border-radius: 7px;
  position: relative;
  .imgItemCnt{
    background-color: #eee;
    width: 50%;
    overflow: hidden;
    position: relative;
    .imgNav{
      position: absolute;
      width: 36px; height: 36px;
      background-color: #fff;
      border-radius: 50%;
      top: 50%;
      margin-top: -18px;
      opacity: .3;
      z-index: 7;
      transition: all .3s ease;
      &:hover{
        opacity: 1 !important;
      }
      &.prev{
        left: 20px;
      }
      &.next{
        right: 20px;
      }
    }
    &:before{
      content: "";
      position: absolute;
      left: 0; right: 0; bottom: 0;
      height: 260px;
      z-index: 1;
      background-image: linear-gradient(transparent, rgba(0,0,0,.8));
    }
    &:hover{
      .imgNav{
        opacity: .65;
      }
    }
    .imgInfo{
      position: absolute;
      left: 20px; right: 20px; bottom: 30px;
      text-align: center;
      color: #fff;
      z-index: 3;
      h4{
        font-size: 26px;
        margin: 0 0 16px;
      }
      p{
        margin: -10px 0 16px;
      }
      .btn{
        background-color: #fff;
        font-weight: 500;
        color: #444;
        font-size: 16px;
      }
    }
    .imgItemSc{
      display: flex;
      .imgItem{
        height: 68vh;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        &.imgItem-1{
          background-image: url(../assets/background-1.jpg);
        }
        &.imgItem-2{
          background-image: url(../assets/background-2.jpg);
        }
        &.imgItem-3{
          background-image: url(../assets/background-3.jpg);
        }
      }
    }
  }
}

.infoCnt{
  .infoWrapper{
    display: flex;
    max-width: 960px;
    margin: 0 auto;
    align-items: center;
    .infoL{
      width: 68%;
      padding: 120px 0;
      h4{
        font-size: 36px;
        margin: 0;
      }
    }
    .infoR{
      width: 32%;
      text-align: right;
      .btn{
        padding: 10px 20px;
        font-size: 20px;
      }
    }
  }
}

.profileAhli{
  padding: 0 0 120px;
  @media (max-width: 640px) {
    padding: 0 0 60px;
  }
  .profileAhliTitle{
    text-align: center;
    margin: 0 0 20px;
    h4{
      font-weight: 500;
      font-size: 30px;
      margin: 0 0 3px;
      @media (max-width: 640px) {
        font-size: 24px;
      }
    }
    p{
      margin: 0;
      font-size: 17px;
      color: #767676;
      @media (max-width: 640px) {
        font-size: 15px;
      }
    }
  }
  .ahliCnt{
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 620px) {
      display: block;
    }
    &.ltf{
      justify-content: center;
    }
    .ahliItem{
      width: calc(25% - 20px);
      text-align: center;
      padding: 30px 20px;
      box-sizing: border-box;
      margin: 0 10px 20px;
      border: #eee 1px solid;
      border-radius: 5px;
      @media (max-width: 1160px) {
        width: calc(33.333333% - 20px);
      }
      @media (max-width: 840px) {
        width: calc(50% - 20px);
      }
      @media (max-width: 620px) {
        width: auto;
        margin: 0 0 20px;
      }
      .ahliPict{
        width: 90px; height: 90px;
        border-radius: 50%;
        margin: 0 auto 24px;
        background-color: #eee;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        &.noImg{
          &:before{
            position: absolute;
            content: "";;
            left: 0; top: 0; right: 0; bottom: 0;
            background-image: url(../assets/image-black.png);
            background-position: center;
            background-size: 36px auto;
            background-repeat: no-repeat;
            opacity: .3;
          }
        }
      }
      .ahliInfo{
        h4{
          margin: 0 0 10px;
          font-size: 20px;
          font-weight: 500;
        }
        .ahliTitle{
          margin: -7px 0 10px;
          font-weight: 400;
          color: #767676;
        }
        .tanggapanCount{
          margin: 0 0 20px;
          color: #767676;
          font-size: 14px;
        }
        .btn{
          font-weight: 500;
          font-size: 16px;
          border-radius: 50px;
        }
      }
    }
  }
}
</style>
